<template>
  <validation-observer tag="div" ref="form">
    <div class="row">
      <validation-provider class="col-6" vid="name" :name="lodash.startCase($t('jala_users.name'))"
        :rules="{ required: true }" v-slot="{ valid, errors }">
        <b-form-group class="row mb-3" label-cols-md="12" :label="lodash.startCase($t('approval_templates.name')) + '*'"
          label-for="name" :state="errors[0] ? false : (valid ? true : null)" :invalid-feedback="errors[0]">
          <b-form-input for="name" type="text" autocomplete="false" required
            :state="errors[0] ? false : (valid ? true : null)" v-model="model.name"></b-form-input>
        </b-form-group>
      </validation-provider>
      <validation-provider class="col-6" vid="approvable_type" :name="lodash.startCase($t('approval_templates.menu'))"
        :rules="{ required: true }" v-slot="{ valid, errors }">
        <b-form-group class="row mb-3" label-cols-md="12"
          :label="lodash.upperFirst($t('approval_templates.menu')) + '*'"
          :state="errors[0] ? false : (valid ? true : null)" :invalid-feedback="errors[0]">
          <multiselect name="approvable_type" :value="selects.approvableTypes.find((t) => (t.id === model.approvable_type))"
            @input="(v) => { model.approvable_type = (v || {}).id }" label="label" :options="selects.approvableTypes">
          </multiselect>
        </b-form-group>
      </validation-provider>
    </div>
    <hr>
    <b-form-group class="row mb-3" label-cols-md="12" :label="lodash.startCase($t('approval_templates.approvers'))"
      label-for="approvers">
      <div style="border: 1px solid #dee2e6; border-radius: 8px;" class="mb-3">
        <table class="table table-borderless mb-0" style="overflow: visible">
          <thead style="background-color: #FAFAFA">
            <tr>
              <th style="border-top-left-radius: 8px">Nama Pengguna</th>
              <th>Level Approver</th>
              <th>Kondisi</th>
              <th style="border-top-right-radius: 8px">Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(step, index) in model.approval_template_steps" :key="index">
              <td style="min-width: 220px">
                <validation-provider :vid="`approver_id_${index}`" :name="`Nama Pengguna ${index + 1}`" :rules="{ required: true }" v-slot="{ errors }">
                  <VueMultiselectAjax :key="`${_uid}-user-${index}`" v-model.number="step.approver_id" url="/users"
                    :params="{ sort: 'name,asc', is_active__eq: 1 }"
                    @update:selected="(v) => $set(model.approval_template_steps[index], 'approver', v)" />
                  <div v-if="errors[0]" class="invalid-feedback d-block">{{ errors[0] }}</div>
                </validation-provider>
              </td>
              <td style="min-width: 120px">
                <validation-provider :vid="`level_${index}`" :name="`Level Approver ${index + 1}`" :rules="{ required: true }" v-slot="{ valid, errors }">
                  <b-form-select v-model.number="step.level" :options="levelOptions" :state="errors[0] ? false : (valid ? true : null)" />
                  <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
              </td>
              <td style="min-width: 160px">
                <validation-provider :vid="`minimum_amount_${index}`" :name="`Kondisi ${index + 1}`" :rules="{ required: true }" v-slot="{ valid, errors }">
                  <!-- <b-form-input type="number" v-model.number="step.minimum_amount" min="0" placeholder="0" :state="errors[0] ? false : (valid ? true : null)" /> -->
                   <numeral-input
                      v-model.number="step.minimum_amount"
                      id="minimum_amount_${index}"
                      name="minimum_amount_${index}"
                      format="$ 0,0.[00]"
                      :state="errors[0] ? false : validated ? true : null"
                  />
                  <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
              </td>
              <td v-if="index > 0">
                <b-button variant="outline-danger" size="sm" @click="removeStep(index)">
                  Hapus
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="p-3">
          <b-button variant="light" class="bg-white" @click="addStep">
            <i class="bx bx-plus"></i>
            Tambah
          </b-button>
        </div>
      </div>
    </b-form-group>

  </validation-observer>
</template>

<script>
import FormModel from './model';
import VueMultiselectAjax from "@/components/inputs/vue-multiselect-ajax";
// import CompanyCreateModal from '../modals/company-create';

export default {
  extends: FormModel,
  components: {
    VueMultiselectAjax,
    // CompanyCreateModal
  },
  data() {
    return {
      model: {
        name: null,
        approvable_type: null,
        ...this.value,
        approval_template_steps: [
          ...((this.value.approval_template_steps || []).length ? this.value.approval_template_steps : (this.value.id ? [{}] : [{}])),
        ],
      },
      selects: {
        /**
         * TODO: ganti jadi model Rencana Pembelian / Rencana Penjualan
         */
        approvableTypes: [
          { id: 'App\\Models\\SaleOrder', label: this.$t('menus.sales') },
          { id: 'App\\Models\\PurchaseOrder', label: this.$t('menus.purchase') },
        ]
      }
    }
  },
  computed: {
    levelOptions() {
      return [1, 2, 3, 4, 5].map((n) => ({
        value: n,
        text: this.$t(`approval_templates.levels.${n}`),
      }));
    },
    typeRadioOptions() {
      let options = this.typeOptions;

      if (this.model.id && this.model.type === 'jala') {
        options = [
          ...this.typeOptions.map((v) => ({ ...v, disabled: true })),
          { text: this.lodash.startCase(this.$t('customers.types.jala')), value: 'jala', disabled: true }
        ]
      }

      return options;
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.$emit('update:errors', {...this.errors, code: ['Diisi coy!!']})
    // }, 5000)
  },
  methods: {
    addStep() {
      this.model.approval_template_steps.push({});
    },
    removeStep(index) {
      if (!this.model.approval_template_steps.length) return null;
      const step = this.model.approval_template_steps[index];
      if ((step || {}).id) {
        this.$set(this.model.approval_template_steps[index], '_action', 'delete');
      } else {
        this.model.approval_template_steps.splice(index, 1);
      }
    },
  }
}
</script>
